// extracted by mini-css-extract-plugin
export default {"listItem":"MealCardsList-module_listItem_rL3knMmnuD","availableToOrder":"MealCardsList-module_availableToOrder_yLnpGzNFEZ"};